import { useMemo } from 'react';
import { useRecoilValue } from 'recoil';

import { dateTimeState } from 'libs/atoms';
import { ObsId } from 'libs/types';

interface UseDelayProps {
  target?: string;
  delayTime: number;
  obsId?: ObsId;
}

function useDelay({ target, delayTime, obsId }: UseDelayProps) {
  const dateTime = useRecoilValue(dateTimeState);

  const delay = useMemo(() => {
    if (!dateTime || dateTime.obsId !== obsId || !target)
      return {
        isDelay: false,
        diffSeconds: 0,
      };

    const targetDate = new Date(target.replaceAll('-', '/'));
    const cntDate = new Date(`${dateTime?.date.replaceAll('-', '/')} ${dateTime?.time}`);
    const diff = (cntDate.getTime() - targetDate.getTime()) / 1000;

    return {
      isDelay: diff >= delayTime,
      diffSeconds: diff,
    };
  }, [dateTime, target, delayTime, obsId]);

  return delay;
}

export default useDelay;
